export const Noise = () => <div className="fw-noise" aria-hidden="true" />;
